import React from 'react';
import { Link } from 'react-router-dom';
import { Container, Row, Col } from 'react-bootstrap';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="footer">
      <Container fluid className="footer-container">
        <Row className="footer-grid">
          <Col lg={5} md={12} className="footer-brand">
            <div className="footer-logo">
              <img src={process.env.PUBLIC_URL + '/Sayagain.png'} alt="SayAgain" className="footer-logo-img" />
            </div>
            <p className="footer-desc">
              Preserving the voices that matter most. Create AI avatars of yourself
              or loved ones, so wisdom and connection can live on.
            </p>
          </Col>

          <Col lg={2} md={4} sm={6} className="footer-col">
            <h4>Product</h4>
            <Link to="/signup">How It Works</Link>
            {/* <Link to="/">Pricing</Link>
            <Link to="/">FAQ</Link> */}
          </Col>

          <Col lg={2} md={4} sm={6} className="footer-col">
            <h4>Legal</h4>
            <Link to="/privacy">Privacy</Link>
            <Link to="/contact">Contact us</Link>
            {/* <Link to="/">Security</Link> */}
          </Col>

          <Col lg={2} md={4} sm={6} className="footer-col">
            {/* <h4>Legal</h4>
            <Link to="/privacy">Privacy</Link> */}
            {/* <Link to="/">Security</Link> */}
          </Col>
        </Row>

        <div className="footer-bottom">
          © {new Date().getFullYear()} SayAgain. All rights reserved.
        </div>
      </Container>
    </footer>
  );
};

export default Footer;

